import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n/LanguageContext";
import "./legal.css";

function TermsOfService() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isNe = lang === "ne";

  const toc = isNe
    ? [
        "शर्त स्वीकृति",
        "सेवा विवरण",
        "पात्रता",
        "भूमिका र जिम्मेवारी",
        "आवेदन र स्वीकृति",
        "निषेधित गतिविधि",
        "कागजात र प्रमाणिकरण",
        "शुल्क र भुक्तानी",
        "सञ्चार",
        "गोपनीयता",
        "बौद्धिक सम्पत्ति",
        "अस्वीकरण",
        "दायित्व सीमा",
        "क्षतिपूर्ति",
        "निलम्बन र समाप्ति",
        "लागू कानुन र विवाद",
        "शर्त परिवर्तन",
        "सम्पर्क",
      ]
    : [
        "Acceptance of Terms",
        "Service Description",
        "Eligibility",
        "User Roles and Responsibilities",
        "Applications and Approvals",
        "Prohibited Conduct",
        "Document Uploads and Verification",
        "Fees and Payments",
        "Communications",
        "Privacy",
        "Intellectual Property",
        "Disclaimers",
        "Limitation of Liability",
        "Indemnity",
        "Suspension and Termination",
        "Governing Law and Disputes",
        "Changes to Terms",
        "Contact",
      ];

  const sections = isNe
    ? [
        {
          id: "tos-acceptance",
          title: "१. शर्त स्वीकृति",
          body: [
            "खाता खोल्दा, सूची हेर्दा, आवेदन गर्दा वा GharBhada प्रयोग गर्दा तपाईं यी सेवा सर्त र गोपनीयता नीतिमा सहमत हुनुहुन्छ। असहमति भए प्लेटफर्म प्रयोग नगर्नुहोस्।",
          ],
        },
        {
          id: "tos-description",
          title: "२. सेवा विवरण",
          body: [
            "GharBhada नेपाल-आधारित डिजिटल प्लेटफर्म हो जसले सम्पत्ति मालिक र भाडावाललाई जोड्छ। हामी सूची, आवेदन र सञ्चारका लागि प्रविधि उपलब्ध गराउँछौं; भाडा सम्झौताका प्रत्यक्ष पक्ष हामी होइनौं।",
          ],
        },
        {
          id: "tos-eligibility",
          title: "३. पात्रता",
          list: [
            "तपाईं कम्तीमा १८ वर्ष पुगेको र नेपालको कानुनअनुसार सम्झौता गर्न सक्षम हुनुपर्छ।",
            "दर्ता जानकारी सही, पूर्ण र अद्यावधिक हुनुपर्छ।",
            "खाता पासवर्ड सुरक्षित राख्ने जिम्मेवारी तपाईंको हो।",
            "पूर्व अनुमति बिना एकभन्दा बढी खाता खोल्न पाइँदैन।",
          ],
        },
        {
          id: "tos-roles",
          title: "४. भूमिका र जिम्मेवारी",
          body: ["मालिकले कानुनी रूपमा भाडा दिन मिल्ने सम्पत्ति मात्र सूचीबद्ध गर्नुपर्छ।"],
          list: [
            "विवरण, फोटो र मूल्य सत्य हुनुपर्छ।",
            "आवेदनमा उचित समयमा प्रतिक्रिया दिनुपर्छ।",
            "भेदभावपूर्ण छनोट प्रक्रिया निषेध छ।",
            "भाडावालले आवेदनमा सत्य जानकारी र वास्तविक कागजात बुझाउनुपर्छ।",
          ],
        },
        {
          id: "tos-applications",
          title: "५. आवेदन र स्वीकृति",
          list: [
            "आवेदन पठाउनु भनेको स्वीकृति सुनिश्चित हुनु होइन।",
            "मालिकले लागू कानुनको दायराभित्र निर्णय गर्छन्।",
            "अनुचित अस्वीकृति लागेको अवस्थामा support@gharbhada.com मा सम्पर्क गर्न सकिन्छ।",
          ],
        },
        {
          id: "tos-prohibited",
          title: "६. निषेधित गतिविधि",
          list: [
            "जाली, गैरकानुनी, अपमानजनक वा अधिकार उल्लंघन सामग्री अपलोड नगर्नुहोस्।",
            "अनधिकृत पहुँच, स्क्र्यापिङ, बोट वा सुरक्षा छल नगर्नुहोस्।",
            "दुर्व्यवहार, धम्की, उत्पीडन वा प्लेटफर्मको दुरुपयोग नगर्नुहोस्।",
          ],
        },
        {
          id: "tos-documents",
          title: "७. कागजात र प्रमाणिकरण",
          list: [
            "अपलोड गरिएका कागजातको वैधता र शुद्धतामा प्रयोगकर्ता जिम्मेवार हुन्छ।",
            "सन्देहास्पद गतिविधिमा हामी छानबिन, सामग्री हटाउने वा खाता निलम्बन गर्न सक्छौं।",
          ],
        },
        {
          id: "tos-fees",
          title: "८. शुल्क र भुक्तानी",
          body: [
            "लागू शुल्क, कमिसन वा भुक्तानी सर्त प्लेटफर्ममा देखाइन्छ। लागू करहरूको जिम्मेवारी प्रयोगकर्तामा रहन्छ जबसम्म छुट्टै रूपमा उल्लेख गरिएको हुँदैन।",
          ],
        },
        {
          id: "tos-communications",
          title: "९. सञ्चार",
          list: [
            "सुरक्षा र दुरुपयोग रोकथामका लागि सन्देशहरू समीक्षा हुन सक्छन्।",
            "सञ्चार सभ्य, कानुनी र भाडा लेनदेनसँग सम्बन्धित हुनुपर्छ।",
            "पासवर्ड रिसेट, आवेदन अपडेट जस्ता आवश्यक इमेल प्राप्त गर्न सहमति हुन्छ।",
          ],
        },
        {
          id: "tos-privacy",
          title: "१०. गोपनीयता",
          body: ["प्लेटफर्म प्रयोग हाम्रो गोपनीयता नीतिद्वारा पनि नियन्त्रित हुन्छ।"],
        },
        {
          id: "tos-ip",
          title: "११. बौद्धिक सम्पत्ति",
          body: [
            "कोड, ब्रान्ड, लोगो, इन्टरफेस र प्लेटफर्म सामग्री GharBhada वा यसका लाइसेन्सदाताको स्वामित्वमा छन्। अनुमति बिना नक्कल/वितरण गर्न पाइँदैन।",
          ],
        },
        {
          id: "tos-disclaimers",
          title: "१२. अस्वीकरण",
          list: [
            "प्लेटफर्म 'as is' आधारमा उपलब्ध हुन्छ।",
            "अविरल वा त्रुटीरहित सेवा ग्यारेन्टी हुँदैन।",
            "भाडा सम्झौतासम्बन्धी अन्तिम जिम्मेवारी सम्झौता पक्षहरूकै हुन्छ।",
          ],
        },
        {
          id: "tos-liability",
          title: "१३. दायित्व सीमा",
          body: [
            "लागू कानुनले अनुमति दिएको हदसम्म, अप्रत्यक्ष, आकस्मिक वा परिणामस्वरूप हुने क्षतिमा GharBhada जिम्मेवार हुँदैन।",
          ],
        },
        {
          id: "tos-indemnity",
          title: "१४. क्षतिपूर्ति",
          body: [
            "तपाईंको सर्त उल्लंघन, गैरकानुनी काम वा तेस्रो पक्ष विवादबाट उत्पन्न दाबी/नोक्सानीमा तपाईंले GharBhada लाई क्षतिपूर्ति दिन सहमत हुनुहुन्छ।",
          ],
        },
        {
          id: "tos-termination",
          title: "१५. निलम्बन र समाप्ति",
          body: [
            "सर्त उल्लंघन, जालसाजी वा कानुनी कारणमा खाता अस्थायी/स्थायी रूपमा बन्द हुन सक्छ। तपाईंले पनि समर्थनमा सम्पर्क गरेर खाता बन्द गर्न सक्नुहुन्छ।",
          ],
        },
        {
          id: "tos-law",
          title: "१६. लागू कानुन र विवाद",
          body: [
            "यी सर्त नेपाल कानुनद्वारा शासित छन्। समाधान नभए काठमाडौं, नेपालको सक्षम अदालतमा विवाद दर्ता गरिनेछ।",
          ],
        },
        {
          id: "tos-changes",
          title: "१७. शर्त परिवर्तन",
          body: [
            "आवश्यक परे यी सर्त अद्यावधिक हुन सक्छन्। महत्त्वपूर्ण परिवर्तन लागू हुनु अघि सूचना दिइनेछ। निरन्तर प्रयोगलाई संशोधित सर्तको स्वीकृति मानिन्छ।",
          ],
        },
        {
          id: "tos-contact",
          title: "१८. सम्पर्क",
          body: ["यी सर्त सम्बन्धी प्रश्नका लागि:"],
        },
      ]
    : [
        {
          id: "tos-acceptance",
          title: "1. Acceptance of Terms",
          body: [
            "By creating an account or using GharBhada, you agree to these Terms of Service and our Privacy Policy. If you do not agree, do not use the platform.",
          ],
        },
        {
          id: "tos-description",
          title: "2. Service Description",
          body: [
            "GharBhada is a Nepal-based marketplace connecting property owners and renters. We provide listing, application, and messaging tools. We are not a direct party to rental contracts unless explicitly stated.",
          ],
        },
        {
          id: "tos-eligibility",
          title: "3. Eligibility",
          list: [
            "You must be at least 18 years old and legally capable of contracting.",
            "You must provide accurate and current account information.",
            "You are responsible for your account credentials.",
            "Multiple accounts are not allowed without prior approval.",
          ],
        },
        {
          id: "tos-roles",
          title: "4. User Roles and Responsibilities",
          body: [
            "Owners must list only lawful properties with truthful details and fair conduct. Renters must submit accurate applications and genuine documents.",
          ],
          list: [
            "No discriminatory screening practices.",
            "Respond to applications in a reasonable timeframe.",
            "Respect communication and rental rules.",
          ],
        },
        {
          id: "tos-applications",
          title: "5. Applications and Approvals",
          list: [
            "Submitting an application does not guarantee approval.",
            "Owners decide approvals subject to applicable law.",
            "For concerns, contact support@gharbhada.com.",
          ],
        },
        {
          id: "tos-prohibited",
          title: "6. Prohibited Conduct",
          list: [
            "No illegal, fraudulent, abusive, or infringing content.",
            "No unauthorized access, scraping, bots, or security bypass.",
            "No harassment, threats, or misuse of the platform.",
          ],
        },
        {
          id: "tos-documents",
          title: "7. Document Uploads and Verification",
          list: [
            "Users are responsible for uploaded document legality and accuracy.",
            "We may investigate suspicious material and suspend violating accounts.",
          ],
        },
        {
          id: "tos-fees",
          title: "8. Fees and Payments",
          body: [
            "Applicable fees and billing terms are shown in-platform. Taxes remain the user responsibility unless otherwise stated.",
          ],
        },
        {
          id: "tos-communications",
          title: "9. Communications",
          list: [
            "Messages may be reviewed for safety and abuse prevention.",
            "Communication must remain lawful and rental-related.",
            "Transactional emails are required for account operations.",
          ],
        },
        {
          id: "tos-privacy",
          title: "10. Privacy",
          body: ["Your use of GharBhada is also governed by our Privacy Policy."],
        },
        {
          id: "tos-ip",
          title: "11. Intellectual Property",
          body: [
            "Platform code, brand assets, and interface materials are owned by GharBhada or its licensors and protected by law.",
          ],
        },
        {
          id: "tos-disclaimers",
          title: "12. Disclaimers",
          list: [
            "Service is provided on an 'as is' and 'as available' basis.",
            "We do not guarantee uninterrupted or error-free operation.",
            "Rental outcomes are between owners and renters.",
          ],
        },
        {
          id: "tos-liability",
          title: "13. Limitation of Liability",
          body: [
            "To the extent permitted by law, GharBhada is not liable for indirect, incidental, or consequential damages.",
          ],
        },
        {
          id: "tos-indemnity",
          title: "14. Indemnity",
          body: [
            "You agree to indemnify GharBhada for claims arising from your misuse, legal violations, or breach of these Terms.",
          ],
        },
        {
          id: "tos-termination",
          title: "15. Suspension and Termination",
          body: [
            "Accounts may be suspended or terminated for violations, fraud, or legal requirements. Users may also request account closure.",
          ],
        },
        {
          id: "tos-law",
          title: "16. Governing Law and Disputes",
          body: [
            "These Terms are governed by Nepal law. Unresolved disputes are submitted to competent courts in Kathmandu, Nepal.",
          ],
        },
        {
          id: "tos-changes",
          title: "17. Changes to Terms",
          body: [
            "We may update these Terms with notice for material changes. Continued use after changes means acceptance.",
          ],
        },
        {
          id: "tos-contact",
          title: "18. Contact",
          body: ["For questions about these Terms:"],
        },
      ];

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <button className="legal-back-btn text-white opacity-75 mb-3" onClick={() => navigate(-1)}>
            {isNe ? "← फिर्ता" : "← Back"}
          </button>
          <h1>{isNe ? "सेवा सर्तहरू" : "Terms of Service"}</h1>
          <p className="legal-meta mb-0">
            {isNe
              ? "प्रभावी मिति: जनवरी १, २०२५ · संस्करण १.० · प्लेटफर्म: GharBhada"
              : "Effective Date: January 1, 2025 · Version 1.0 · Platform: GharBhada"}
          </p>
        </div>
      </div>

      <div className="container">
        <div className="legal-card">
          <div className="legal-toc">
            <h6>{isNe ? "विषयसूची" : "Table of Contents"}</h6>
            <ol>
              {toc.map((item, i) => (
                <li key={item}>
                  <a href={`#${sections[i].id}`}>{item}</a>
                </li>
              ))}
            </ol>
          </div>

          <div className="legal-highlight">
            {isNe
              ? "प्लेटफर्म प्रयोग गर्नु अघि यी सेवा सर्तहरू ध्यानपूर्वक पढ्नुहोस्। खाता सिर्जना वा प्रयोग गर्दा तपाईं यी सर्तमा सहमत हुनुहुन्छ।"
              : "Please read these Terms carefully before using GharBhada. By creating an account or using the platform, you agree to these terms."}
          </div>

          {sections.map((section) => (
            <div className="legal-section" id={section.id} key={section.id}>
              <h2>{section.title}</h2>
              {section.body?.map((p) => (
                <p key={p}>{p}</p>
              ))}
              {section.list && (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div className="legal-contact-box">
            <h5>{isNe ? "GharBhada कानुनी र सहयोग" : "GharBhada Legal & Support"}</h5>
            <p className="mb-1 small">
              Email: <a href="mailto:support@gharbhada.com">support@gharbhada.com</a>
            </p>
            <p className="mb-1 small">
              Legal: <a href="mailto:legal@gharbhada.com">legal@gharbhada.com</a>
            </p>
            <p className="mb-0 small">Address: Kathmandu Valley, Nepal</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
